import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { APP_PAGES } from '../../navigation/app-pages';
import { AuthService } from '../services/auth.service';

/**
 * Define a tela inicial de acordo com o perfil do usuario.
 *
 * - Se o usuario tiver acesso a uma unica pagina da aplicacao, abre direto
 *   nela (sem passar pelo Dashboard).
 * - Senao, perfis com acesso ao Dashboard caem no Dashboard.
 * - Senao, cai na primeira pagina acessivel (ordem de APP_PAGES).
 * - Sem nenhuma pagina acessivel, volta para o login como nao autorizado.
 *
 * Roda como canActivate de uma rota filha do layout autenticado, portanto
 * executa depois do authGuard - garantindo que o usuario ja esteja carregado.
 */
export const landingGuard: CanActivateFn = () => {
  const router = inject(Router);
  const authService = inject(AuthService);

  const paginasAcessiveis = APP_PAGES.filter((pagina) => authService.hasPermission(pagina.permissao));

  if (paginasAcessiveis.length === 1) {
    return router.parseUrl(paginasAcessiveis[0].route);
  }

  if (authService.hasPermission('Dashboard')) {
    return router.parseUrl('/dashboard');
  }

  if (paginasAcessiveis.length > 0) {
    return router.parseUrl(paginasAcessiveis[0].route);
  }

  return router.parseUrl('/login?error=unauthorized');
};
